<template>
	<div class="bigpagebox">
		<div class="header">
			<h3 class="msstitle">聊天信息</h3>
			<span @click="close" class="close">
				<i class="el-icon-close"></i>
			</span>
		</div>
		<div class="imheader">你有{{imnum}}條信息未讀</div>
		<div class="messbox">
			<template>
				
				<ul class="imlist">
					<li v-for="item in imlist">
						<div v-if="item.from_id == user_id" @click.stop="sendim(item.to_id)" class="libox">
							<div class="userbox">
								<div class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+(apiurl+item.to_thumb)+')'}">
								<!-- <div v-if="item.imnum>0" class="newnum">{{item.imnum}}</div> -->
								</div>
								
							</div>
							<div class="imbox">
								<div class="msheader">
									<div class="username">{{item.to_username}}</div>
									<div class="addtime">{{item.addtime}}</div>
								</div>
								<div class="imcontent" v-html="item.content"></div>
							</div>
						</div>
						<div v-else="item.from_id == user_id" @click.stop="sendim(item.from_id)" class="libox">
							<div class="userbox">
								<div class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+(apiurl+item.from_thumb)+')'}">
								<div v-if="item.imnum>0" class="newnum">{{item.imnum}}</div>
								</div>
							</div>
							<div class="imbox">
								<div class="msheader">
									<div class="username">{{item.from_username}}</div>
									<div class="addtime">{{item.addtime}}</div>
								</div>
								<div class="imcontent" v-html="item.content"></div>
							</div>
						</div>
					</li>
					
				</ul>
			</template>
		</div>


	</div>
</template>

<script>
	export default {
		props: ['listrefim'],

		data() {
			return {
				
				imnum:0,
				imlist:{},
				user_id:0,
			}
		},
		watch: {
			listrefim() {
				
				this.getim_message_list();
				this.getimnum();
			}

		},
		methods: {
			sendim(to_id){
				this.$emit('sendim', to_id);
			},
			getimnum(){
				let user_id = parseInt(sessionStorage.getItem('user_id'));
				this.post('/api/im/imnum', {
					user_id: user_id
				}).then((res) => {
					this.imnum = res;
				})
			},

			close() {
				this.$emit('closemsgcenter', false);
			},
			getim_message_list(){
				let user_id = parseInt(sessionStorage.getItem('user_id'));
				this.post('/api/im/im_message_list', {
					user_id: user_id
				}).then((res) => {
					
					this.imlist = res;
					
				})
			},



		},
		created() {
			this.user_id = parseInt(sessionStorage.getItem('user_id'));
			this.getim_message_list();
			this.getimnum();
		}
	}
</script>

<style>
	.imheader{ padding:0 15px; padding-bottom: 5px;}
	.imcontent{ line-height: 1.5; padding: 10px 0; display: flex; align-items: center;}
	.addtime{ font-size: 12px; color: #999;}
	.imlist{ padding: 15px 0;}
	.imlist>li{ margin-bottom: 10px; border-bottom: 1px solid #e2e2e2;}
	.imbox {
		flex: 1 auto;
	}
	.msheader {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.userbox {
		flex: 0 0 45px;
		margin-right: 10px;
		
	}
	
	.userface {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		margin-right: 10px;
		margin-bottom: 10px;
		position: relative;
	}
	.newnum{ position: absolute; top: -5px; right: -10px; width: 20px; height: 20px; background: #F56C6C; color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center;}
	.imlist .libox {
		display: flex;
	}
	.close {
		border-radius: 50%;
		font-size: 18px;
		width: 25px;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #3399ff;
		color: #fff;
	}
	
	.header {
		padding: 15px;
		display: flex;
		justify-content: space-between;
		position: relative;
	}

	.messbox {
		height: calc(100vh - 130px);
		overflow-x: hidden;
		padding: 0 15px;
	}

	.msstitle {
		text-align: center;
	}
</style>
